import { lazy, Suspense } from "react";
import TwoFactorSetup from "../Settings/TwoFactorSetup";
import TwoFactorVerify from "./TwoFactorVerify";

const Signup = lazy(() => import("./Signup"));
const Signin = lazy(() => import("./Signin"));
const Error404 = lazy(() => import("./Error"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const Resetpasswordpage = lazy(() => import("./Resetpasswordpage"));


const sessionsRoutes = [
  {
    path: "/sessions/signup",
    element: (
      <Suspense>
        <Signup />
      </Suspense>
    )
  },
  {
    path: "/sessions/signin",
    element: (
      <Suspense>
        <Signin />
      </Suspense>
    )
  },
  {
    path: "/sessions/forgot-password",
    element: (
      <Suspense>
        <ForgotPassword />
      </Suspense>
    )
  },
  {
    path: "/sessions/404",
    element: (
      <Suspense>
        <Error404 />
      </Suspense>
    )
  },
  {
    path: "/sessions/reset-password",
    element: (
      <Suspense>
        <Resetpasswordpage />
        </Suspense>
    )
  },{

    path:"/verify-2fa",
    element:(
      <Suspense>
        <TwoFactorVerify/>
      </Suspense>
    )
  }
];

export default sessionsRoutes;